module.exports = __webpack_public_path__ + "static/media/light-leaks.352eca33.png";